<template>
<div>
<Wallet :key="reviewApplication"></Wallet>

</div>
</template>

<script>
import Wallet from "../../components/Applicant/Wallet.vue";


export default {
  components: {
   Wallet
  },
  created() {

  },
  computed:{
    reviewApplication(){
       return  this.$store.state.auth.renderReview 

        
       }
  }
};
</script>

<style scoped>


</style>